import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import { Tabs, Tab } from "material-ui/Tabs";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";

import { Page, Loadable, Errorable, IconButton } from "components/support";

import { colors } from "assets";

import CompanyAccountantInfo from "./accountant-info";
import CompanyGeneralInfo from "./general-info";
import CompanyGeographicInfo from "./geographic-info";
import CompanyIntegrations from "./integrations";
import CompanyAppConfig from "./config-app";

export default class CompanyViewView extends Component {
  constructor(props) {
    super(props);
    this.presenter = props.presenter;
  }

  render() {
    const { loading, error, company, currentUser } = this.props.viewModel;

    return (
      <Page>
        <Row>
          <Col xs={12}>
            <Typography type="display1" className="pb-sm">
              <Row>
                <Col xs>
                  <IconButton
                    icon="arrow_back"
                    onClick={() => this.presenter.onGoBack()}
                  />
                  {company
                    ? company.slug || company.name
                    : "Visualizar Empresa"}
                </Col>
                <Col>
                  <IconButton
                    icon="mode_edit"
                    onClick={() => this.presenter.onEdit()}
                  />
                </Col>
              </Row>
            </Typography>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Errorable error={!!error} errorMessage={error}>
              <Loadable loading={loading}>
                <Paper elevation={1}>
                  <Tabs
                    inkBarStyle={{ backgroundColor: colors.accent.normal }}
                    tabItemContainerStyle={{
                      backgroundColor: colors.primary.dark
                    }}
                    className="company-form-tabs"
                  >
                    <Tab label="Geral" className="tab-content">
                      {company && (
                        <CompanyGeneralInfo
                          company={company}
                          currentUser={currentUser}
                        />
                      )}
                    </Tab>
                    <Tab label="Endereço" className="tab-content">
                      {company && <CompanyGeographicInfo company={company} />}
                    </Tab>
                    <Tab label="Contabilidade" className="tab-content">
                      {company && <CompanyAccountantInfo company={company} />}
                    </Tab>
                    <Tab label="Integrações" className="tab-content">
                      {company && <CompanyIntegrations company={company} />}
                    </Tab>
                    <Tab
                      label="Configuração do Aplicativo"
                      className="tab-content"
                    >
                      {company && <CompanyAppConfig company={company} />}
                    </Tab>
                  </Tabs>
                </Paper>
              </Loadable>
            </Errorable>
          </Col>
        </Row>
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/company/view/company-view.view.jsx